// Mirrors PragyaLIMS.PIF.Models/PifEnum.cs. FormID has no shared constant in this
// codebase; these are the wire values the PIF API returns.

import moment from "moment";

// Date/time display — same format the rest of PragyaLIMS uses (Testing, SampleDispose, …):
// "01-Sep-2026 02:58 pm". The PIF API returns server-local time with no zone.
export const pifDateTime = (dt) => {
  if (!dt) return "—";
  const m = moment(dt);
  return m.isValid() ? m.format("DD-MMM-YYYY hh:mm a") : "—";
};

export const pifDateOnly = (dt) => {
  if (!dt) return "—";
  const m = moment(dt);
  return m.isValid() ? m.format("DD-MMM-YYYY") : "—";
};

export const PIF_QUEUE_STATUS = {
  1: { label: "Ready", badge: "primary" },
  2: { label: "In Progress", badge: "warning" },
  3: { label: "Synced", badge: "success" },
  4: { label: "Blocked", badge: "danger" },
  5: { label: "Dead", badge: "dark" },
};

export const PIF_JOB_TYPE = {
  1: "Invoice",
  2: "Master Push",
  3: "Master Validation",
  4: "Invoice Cancel",
};

export const PIF_FAILURE_CLASS = {
  1: "Transient",
  2: "Blocked",
  3: "Permanent",
};

export const PIF_FAILOUT_REASON = {
  0: "",
  1: "Missing master in Tally",
  2: "Unmapped master",
  3: "Unmapped unit",
  4: "Duplicate party ledger",
  5: "Customer GSTIN missing",
  6: "Bound Tally company not loaded",
  7: "Incomplete configuration",
  8: "Authentication failure",
  9: "Invalid XML",
  10: "Tax total mismatch",
  11: "Tally unreachable",
  12: "Tally busy",
};

export const PIF_INTEGRATION_STATUS = {
  1: { label: "Pending", badge: "warning" },
  2: { label: "Active", badge: "success" },
  3: { label: "Suspended", badge: "danger" },
};

// Sync-status pill for the invoice list (S8). Invoice.PifSyncStatus reuses the queue status,
// plus 6 = "Cancelled in Tally" (set when a JobType 4 InvoiceCancel job succeeds).
export const pifInvoiceSyncPill = (status) => {
  if (status == null) return null;
  if (status == 6) return { label: "Cancelled in Tally", badge: "dark" };
  return PIF_QUEUE_STATUS[status] || { label: "—", badge: "secondary" };
};

// Pill for a cancelled invoice's JobType 4 (InvoiceCancel) job — CancelJobStatus is the
// queue status of that job, or null when no cancel has been queued.
export const pifCancelJobPill = (status) => {
  if (status == null) return null;
  if (status == 3) return { label: "Cancelled in Tally", badge: "dark" };
  if (status == 4 || status == 5) return { label: "Cancel failed", badge: "danger" };
  return { label: "Cancel pending", badge: "warning" }; // 1 Ready / 2 Claimed
};
